<template>
  <label
    :for="id + '_toggle'"
    :class="{ active: isActive }"
    class="toggle__button"
  >
    <input
      type="checkbox"
      :disabled="disabled"
      :id="id + '_toggle'"
      v-model="checkedValue"
    />
    <span class="toggle__switch"></span>
  </label>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'primary',
    },
    defaultState: {
      type: Boolean,
      default: true,
    },
    //    ref: {
    //      type: String,
    //      default: "",
    //    }
  },
  data() {
    return {
      currentState: this.defaultState,
    };
  },
  watch: {
    defaultState: function defaultState() {
      this.currentState = Boolean(this.defaultState);
    },
  },
  computed: {
    isActive() {
      return this.currentState;
    },
    checkedValue: {
      get() {
        return this.currentState;
      },
      set(newValue) {
        this.currentState = newValue;
        this.$emit('change', newValue);
      },
    },
  },
};
</script>

<style scoped>
/* Change cursor type */
.toggle__button {
  vertical-align: middle;
  user-select: none;
  cursor: pointer;
}

/* Make checkbox invisble */
.toggle__button input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}

/* Track (Enabled off)*/
.toggle__button .toggle__switch {
  display: inline-block;
  height: 12px;
  border-radius: 6px;
  width: 32px;
  position: relative;
  margin-left: 10px;
  transition: all 0.25s;
}

/* Thumb (Enabled Off) */
.toggle__button .toggle__switch::after,
.toggle__button .toggle__switch::before {
  content: "";
  position: absolute;
  display: block;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  left: 0;
  top: -3px;
  transform: translateX(0);
  transition: all 0.25s cubic-bezier(0.5, -0.6, 0.5, 1.6);
}

/* Track (Enabled Off)*/
.toggle__button .toggle__switch {
  background: #9B9B9B;
  box-shadow: -0.3px 1px 1px 0 #C0C0C0;
}
/* Track (Enabled On)*/
.active .toggle__switch {
  background: rgb(241, 183, 174);
  box-shadow: 0.3px 1px 1px 0 #C0C0C0;
}

/* Thumb (Enabled Off) */
.toggle__button .toggle__switch::after {
  background: rgb(255, 255, 255);
  box-shadow: 0 1px 1px 1px #C0C0C0;
}
/* Thumb (Enabled On) */
.active .toggle__switch::after {
  left: 14px;
  background: #E75239;
  box-shadow: 0.3px 1px 1px 1px #C0C0C0;
}

.active .toggle__switch::after,
.active .toggle__switch::before {
  transform: translateX(40px - 15px);
}

.disable .toggle__switch {
  background: #C8C8C8 !important;
  box-shadow: 0 1px 1px 0 #C0C0C0 !important;
}
/* Thumb (Disabled Off) */
.disable .toggle__switch::after {
  background: #EEEEEE !important;
  box-shadow: 0 1px 1px 1px #D7D7D7 !important;
}
.disable {
  cursor: unset !important;
}

</style>
